/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @legacy
 * @alpha
 */
export var CreateSummarizerNodeSource;
(function (CreateSummarizerNodeSource) {
    CreateSummarizerNodeSource[CreateSummarizerNodeSource["FromSummary"] = 0] = "FromSummary";
    CreateSummarizerNodeSource[CreateSummarizerNodeSource["FromAttach"] = 1] = "FromAttach";
    CreateSummarizerNodeSource[CreateSummarizerNodeSource["Local"] = 2] = "Local";
})(CreateSummarizerNodeSource || (CreateSummarizerNodeSource = {}));
/**
 * @internal
 */
export const channelsTreeName = ".channels";
/**
 * @internal
 */
export const blobCountPropertyName = "BlobCount";
/**
 * @internal
 */
export const totalBlobSizePropertyName = "TotalBlobSize";
//# sourceMappingURL=summary.js.map